import scrollAndFocus from "./scrollfocus.js";

const DEFAULTS = {
    position: "afterbegin",
    boxId: "ErrorBox"
};

class ErrorBox {
    constructor() {
        this.scrollPromise = null;
    }

    async createBox(){
        return `
            <div id="${DEFAULTS.boxId}" class="ErrorMsgPanel" role="alert" aria-atomic="true">
                <h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>
                <ul id="ErrorMsgBox"></ul>
            </div>`;
    }

    async show(container, position = DEFAULTS.position) {
        if (!container) {
            console.error("ErrorBox: No valid container provided.");
            return;
        }

        this.removeBox(); // remove old box if any
        const errorBox = await this.createBox();
        container.insertAdjacentElement(position, errorBox);
        scrollAndFocus(errorBox);
    }

    removeBox() {
        const box = document.getElementById(DEFAULTS.boxId);
        if (box) box.remove();
    }
}

export default new ErrorBox();